import { render, staticRenderFns } from "./WizardStepJobMatchLocation.vue?vue&type=template&id=b47174e4&lang=pug&"
import script from "./WizardStepJobMatchLocation.vue?vue&type=script&lang=ts&"
export * from "./WizardStepJobMatchLocation.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStepJobMatchLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b47174e4')) {
      api.createRecord('b47174e4', component.options)
    } else {
      api.reload('b47174e4', component.options)
    }
    module.hot.accept("./WizardStepJobMatchLocation.vue?vue&type=template&id=b47174e4&lang=pug&", function () {
      api.rerender('b47174e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard-pages/jobmatch-steps/WizardStepJobMatchLocation.vue"
export default component.exports